<template>
  <div class="addRole_cxw">
    <div class="addRole">
      <span class="top">修改线索</span>
      <el-form
        status-icon
        :rules="rules"
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
      >
        <p class="subtitle">基本信息</p>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="姓名:"
              prop="userName"
            >
              <el-input
                type="text"
                v-model.trim="ruleForm.userName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="性别:"
              prop="gender"
            >
              <el-select
                v-model="ruleForm.gender"
                placeholder="请选择性别"
              >
                <el-option
                  v-for="item in genderSelect"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="手机号:"
              prop="phone"
            >
              <el-input
                type="text"
                v-model="ruleForm.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="出生日期:"
              prop="birthday"
            >
              <el-date-picker
                v-model="ruleForm.birthday"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="请选择出生日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="证件类型:"
              prop="idType"
            >
              <el-select
                v-model="ruleForm.idType"
                placeholder="请选择证件类型"
              >
                <el-option
                  v-for="item in idTypeSelect"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="证件号码:"
              prop="idNumber"
            >
              <el-input
                type="text"
                v-model="ruleForm.idNumber"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="8"
            class='nationstyle'
          >
            <el-form-item label="国籍/民族:">
              <el-select
                v-model="ruleForm.nation"
                placeholder="国籍"
              >
                <el-option
                  v-for="item in nationDropList"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
              <el-select
                v-model="ruleForm.people"
                placeholder="民族"
              >
                <el-option
                  v-for="item in peopleDropList"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="11"
            class='adressstyle'
          >
            <el-form-item label="户籍所在地:">
              <el-select
                v-model="ruleForm.residenceProvinceCode"
                placeholder="省"
                @change="getCity('2')"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.provinceId"
                  :label="item.provinceName"
                  :value="item.provinceId"
                ></el-option>
              </el-select>
              <el-select
                v-model="ruleForm.residenceCityCode"
                placeholder="市"
                @change="getArea('2')"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.provinceId"
                  :label="item.provinceName"
                  :value="item.provinceId"
                ></el-option>
              </el-select>
              <el-select
                v-model="ruleForm.residenceDistrictCode"
                placeholder="区"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.provinceId"
                  :label="item.provinceName"
                  :value="item.provinceId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="5"
            class="address-container"
          >
            <el-form-item prop="residenceAddress">
              <el-input
                placeholder="请输入详细地址"
                type="text"
                v-model="ruleForm.residenceAddress"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="婚姻状态:"
              prop="marriage"
            >
              <el-select
                v-model="ruleForm.marriage"
                placeholder="请选择婚姻状态"
              >
                <el-option
                  v-for="item in maritalStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="11"
            class='adressstyle'
          >
            <el-form-item
              label="居住地:"
              prop=""
            >
              <el-select
                v-model="ruleForm.addressProvinceCode"
                placeholder="省"
                @change="getAdressCity('2')"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.provinceId"
                  :label="item.provinceName"
                  :value="item.provinceId"
                ></el-option>
              </el-select>
              <el-select
                v-model="ruleForm.addressCityCode"
                placeholder="市"
                @change="getAdressArea('2')"
              >
                <el-option
                  v-for="item in cityAdressList"
                  :key="item.provinceId"
                  :label="item.provinceName"
                  :value="item.provinceId"
                ></el-option>
              </el-select>
              <el-select
                v-model="ruleForm.addressDistrictCode"
                placeholder="区"
              >
                <el-option
                  v-for="item in areaAdressList"
                  :key="item.provinceId"
                  :label="item.provinceName"
                  :value="item.provinceId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="5"
            class="address-container"
          >
            <el-form-item prop="address">
              <el-input
                placeholder="请输入详细地址"
                type="text"
                v-model="ruleForm.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="学历:"
              prop="education"
            >
              <el-select
                v-model="ruleForm.education"
                placeholder="请选择学历"
              >
                <el-option
                  v-for="item in educationSelect"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="子女情况:"
              prop="fertilityStatus"
            >
              <el-input
                placeholder="请输入子女数"
                type="text"
                v-model="ruleForm.fertilityStatus"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <p class="subtitle">资产信息</p>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="职业:"
              prop="profession"
            >
              <el-input
                placeholder="请输入职业"
                type="text"
                v-model="ruleForm.profession"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="行业类型:"
              prop="industry"
            >
              <el-input
                placeholder="请输入行业"
                type="text"
                v-model="ruleForm.industry"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="年收入:"
              prop="incomeYearly"
            >
              <el-select
                v-model="ruleForm.incomeYearly"
                placeholder="请选择年收入"
              >
                <el-option
                  v-for="item in incomeSelect"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="是否有房:"
              prop="hasHouse"
            >
              <el-select v-model="ruleForm.hasHouse">
                <el-option
                  label="是"
                  value="1"
                ></el-option>
                <el-option
                  label="否"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="是否有车:"
              prop="hasCar"
            >
              <el-select v-model="ruleForm.hasCar">
                <el-option
                  label="是"
                  value="1"
                ></el-option>
                <el-option
                  label="否"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <p class="subtitle">相关信息</p>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="客户备注:"
              prop="remark"
            >
              <el-input
                type="textarea"
                v-model="ruleForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="btn_bottom">
          <el-button @click="isEdit">取消</el-button>
          <el-button
            type="primary"
            @click="save"
          >保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { addNav } from '@/mixins';
import { validatePhone, validateIDNo } from '@/utils/validators';

export default {
  name: 'AddRole',
  mixins: [addNav],
  data() {
    function validateUserName(rule, value, callback) {
      if (value && value.length > 20) {
        callback(new Error('最多输入20个字符'));
      } else {
        callback();
      }
    }
    function validatePhoneInput(rule, value, callback) {
      if (value && !/^[0-9]*$/.test(value)) {
        callback(new Error('仅支持数字输入'));
      } else {
        callback();
      }
    }
    function validateMark(rule, value, callback) {
      if (value && value.length > 200) {
        callback(new Error('最多输入200个字符'));
      } else {
        callback();
      }
    }
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    const detailData = JSON.parse(sessionStorage.getItem('detailData'));
    if (detailData.birthday) {
      detailData.birthday = new Date(detailData.birthday);
    }
    // FIXME: value label 中，value 有数字，有字符串
    return {
      ruleForm: {
        ...detailData,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      nationDropList: [],
      peopleDropList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      cityAdressList: [],
      areaAdressList: [],
      genderSelect: [],
      maritalStatusList: [
        {
          label: '未婚',
          value: '0',
        },
        {
          label: '已婚',
          value: '1',
        },
      ],
      idTypeSelect: [],
      incomeSelect: [],
      educationSelect: [],
      orgnCode: sessionData.orgnCode,
      orgnName: sessionData.orgnName,
      rules: {
        userName: [
          { required: true, message: '请填写人员姓名！', trigger: 'blur' },
          {
            validator: validateUserName,
            trigger: 'blur',
          },
        ],
        phone: [
          {
            validator: validatePhoneInput,
          },
          {
            validator: validatePhone,
            message: this.$MSG.M0009,
            trigger: 'blur',
          },
        ],
        idNumber: [
          {
            validator: validateIDNo,
            message: this.$MSG.M0008,
            trigger: 'blur',
          },
        ],
        remark: [
          {
            validator: validateMark,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {
    this.currentOrgnCode = JSON.parse(
      sessionStorage.getItem('sessionData'),
    ).orgnCode;
    this.getNationList();
    this.getPeopleList();
    this.getProvinceList();
    this.getGenderList();
    this.getIdType();
    this.getEducation();
    this.getIncome();
    if (
      this.ruleForm.residenceProvinceCode
      || this.ruleForm.residenceCityCode
    ) {
      this.getCity('1');
    }
    if (this.ruleForm.residenceDistrictCode) {
      this.getArea('1');
    }
    if (this.ruleForm.addressProvinceCode || this.ruleForm.addressCityCode) {
      this.getAdressCity('1');
    }
    if (this.ruleForm.addressDistrictCode) {
      this.getAdressArea('1');
    }
  },

  methods: {
    // 国籍
    getNationList() {
      const parames = {
        data: {
          dictTypeCode: 'countryType',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=1`, parames).then((res) => {
        this.nationDropList = res.data.list;
      });
    },
    // 民族
    getPeopleList() {
      const parames = {
        data: {
          dictTypeCode: 'nationType',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=2`, parames).then((res) => {
        this.peopleDropList = res.data.list;
      });
    },
    // 省
    getProvinceList() {
      const parames = {
        data: {
          parentId: '000000',
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=1`, parames).then((res) => {
        this.provinceList = res.data.list;
      });
    },
    // 性别
    getGenderList() {
      const parames = {
        data: {
          dictTypeCode: 'gender',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=3`, parames).then((res) => {
        this.genderSelect = res.data.list;
      });
    },
    // 证件类型
    getIdType() {
      const parames = {
        data: {
          dictTypeCode: 'credentialsType',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=4`, parames).then((res) => {
        this.idTypeSelect = res.data.list;
      });
    },
    // 学历
    getEducation() {
      const parames = {
        data: {
          dictTypeCode: 'salesLeadEducation',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=5`, parames).then((res) => {
        this.educationSelect = res.data.list;
      });
    },
    // 年收入
    getIncome() {
      const parames = {
        data: {
          dictTypeCode: 'sqlesLeadIncome',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=6`, parames).then((res) => {
        this.incomeSelect = res.data.list;
      });
    },
    // 市
    getCity(isChange) {
      if (isChange === '1') {
        const parames = {
          data: {
            parentId: this.ruleForm.residenceProvinceCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=2`, parames).then((res) => {
          this.cityList = res.data.list;
        });
      }
      if (isChange === '2' && this.ruleForm.residenceDistrictCode) {
        this.ruleForm.residenceCityCode = '';
        this.ruleForm.residenceDistrictCode = '';
        const parames = {
          data: {
            parentId: this.ruleForm.residenceProvinceCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=2`, parames).then((res) => {
          this.cityList = res.data.list;
        });
      }
      this.ruleForm.residenceCityCode = '';
      const parames = {
        data: {
          parentId: this.ruleForm.residenceProvinceCode,
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=2`, parames).then((res) => {
        this.cityList = res.data.list;
      });
    },
    // 区
    getArea(isChange) {
      if (isChange === '1') {
        const parames = {
          data: {
            parentId: this.ruleForm.residenceCityCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=3`, parames).then((res) => {
          this.areaList = res.data.list;
        });
      }
      if (isChange === '2') {
        if (this.ruleForm.residenceDistrictCode) {
          this.ruleForm.residenceDistrictCode = '';
        }
        const parames = {
          data: {
            parentId: this.ruleForm.residenceCityCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=3`, parames).then((res) => {
          this.areaList = res.data.list;
        });
      }
      return '';
    },
    // 市
    getAdressCity(isChange) {
      if (isChange === '1') {
        const parames = {
          data: {
            parentId: this.ruleForm.addressProvinceCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=4`, parames).then((res) => {
          this.cityAdressList = res.data.list;
        });
      }
      if (isChange === '2' && this.ruleForm.addressDistrictCode) {
        this.ruleForm.addressCityCode = '';
        this.ruleForm.addressDistrictCode = '';
        const parames = {
          data: {
            parentId: this.ruleForm.addressProvinceCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=4`, parames).then((res) => {
          this.cityAdressList = res.data.list;
        });
      }
      this.ruleForm.addressCityCode = '';
      const parames = {
        data: {
          parentId: this.ruleForm.addressProvinceCode,
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=4`, parames).then((res) => {
        this.cityAdressList = res.data.list;
      });
    },
    // 区
    getAdressArea(isChange) {
      if (isChange === '1') {
        const parames = {
          data: {
            parentId: this.ruleForm.addressCityCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=5`, parames).then((res) => {
          this.areaAdressList = res.data.list;
        });
      }
      if (isChange === '2') {
        if (this.ruleForm.addressDistrictCode) {
          this.ruleForm.addressDistrictCode = '';
        }
        const parames = {
          data: {
            parentId: this.ruleForm.addressCityCode,
          },
        };
        return this.$_post(`${this.$API.adressGet}?v=5`, parames).then((res) => {
          this.areaAdressList = res.data.list;
        });
      }
      return '';
    },
    // 修改保存
    save() {
      // eslint-disable-next-line consistent-return
      this.$refs.ruleForm.validate((valid) => {
        console.log('validvalid', valid);
        if (valid) {
          this.editLeadData();
        } else {
          return false;
        }
      });
    },
    // 修改确定
    editLeadData() {
      const sessiondata = JSON.parse(sessionStorage.getItem('sessionData'));
      const parames = {
        data: {
          ...this.ruleForm,
          updateUserId: sessiondata.userId,
          ownerOrganizationId: sessiondata.orgnId,
          ownerOrganizationCode: sessiondata.orgnCode,
          ownerOrganizationName: sessiondata.orgnName,
        },
      };
      this.$_post(this.$API.leadEdit, parames)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success('修改成功!');
            this.deletePage('/editLead');
            this.addNav({
              name: '线索客户',
              path: '/leadCust',
            });
          } else {
            this.$message.error(res.errorMsg);
            this.deletePage('/editLead');
          }
        })
        .catch((res) => {
          this.$message.error(res.errorMsg);
          this.deletePage('/editLead');
        });
    },
    // 取消修改
    isEdit() {
      this.$_yh_confirm('确认取消，取消后信息将不保存').then(() => {
        this.deletePage('/editLead');
        this.addNav({
          name: '线索客户',
          path: '/leadCust',
        });
      });
    },
    // 删除标签页,取消按钮
    deletePage(path) {
      this.$store.commit('removeTab', path);
    },
  },
};
</script>
<style scoped lang="scss">
.subtitle {
  padding: 20px 0 0 1em;
  text-align: left;
  color: #409eff;
}
.addRole {
  width: 100%;
  height: 100%;
  .top {
    color: #bfbfbf;
  }
}
.btn_bottom {
  margin-top: 20px;
  text-align: center;
}
.addRole .el-input,
.addRole .el-select {
  width: 90% !important;
}
.adressstyle .el-select {
  width: 33.3% !important;
}
.adressstyle .el-input {
  width: 28% !important;
}
.nationstyle .el-select {
  width: 45% !important;
}
</style>
<style>
.addRole_cxw .addRole .el-form-item__error {
  margin-left: 35%;
}
.address-container .el-form-item__content {
  margin-left: 0 !important;
}
</style>
